// CSS Modules - component class name prefix: TextMediaElement__

<template>
  <figure
    :class="[{ TextMediaElement__mediaRight: mediaRight }, $style.container]"
  >
    <div :class="$style.mediaWrapper">
      <HeroSlider v-if="slides" :slides="slides" />
      <a
        v-if="video"
        :class="[$style.mediaLink, $style.videoLink]"
        @click="openModal"
      >
        <i class="fab fa-youtube"></i>
        <img :src="image" :alt="title" />
      </a>
    </div>
    <figcaption>
      <h2>{{ title }}</h2>
      <div v-html="text"></div>
    </figcaption>
    <Modal
      v-if="video"
      :isModalOpen="isModalOpen"
      :isVideo="true"
      :isNotYouTube="true"
      @closeModal="closeModal"
    >
      <video ref="video" controls>
        <source v-if="isMp4" :src="video" type="video/mp4" />
        <source v-else :src="video" type="video/webm" />
      </video>
    </Modal>
  </figure>
</template>

<script>
import HeroSlider from "../HeroSlider/HeroSlider.vue";
import Modal from "../Modal/Modal.vue";

export default {
  name: "TextMediaElement",
  components: {
    HeroSlider,
    Modal
  },
  props: {
    mediaRight: {
      type: Boolean,
      default: false
    },
    isMp4: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    slides: {
      type: Array,
      default: () => []
    },
    video: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isModalOpen: false
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
      if (this.$refs.video) {
        this.$refs.video.load();
      }
    },
    closeModal() {
      if (this.$refs.video) {
        this.$refs.video.pause();
      }
      this.isModalOpen = false;
    }
  }
};
</script>

<style module lang="scss">
@import "./TextMediaElement.scss";
</style>
